import UpdatePasswordGeneric from './UpdatePasswordGeneric';

const UpdatePasswordCliente = () => {
    return (
        <UpdatePasswordGeneric
            verifyTokenRoute="/area-generale/reset-password/verify-token"
            changePasswordRoute="/area-generale/reset-password/change-password"
            loginRoute="/login"
        />
    );
};

export default UpdatePasswordCliente;
